import { render, staticRenderFns } from "./CompanyProfilePage.vue?vue&type=template&id=72011f79&scoped=true&"
import script from "./CompanyProfilePage.vue?vue&type=script&lang=js&"
export * from "./CompanyProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfilePage.vue?vue&type=style&index=0&id=72011f79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72011f79",
  null
  
)

export default component.exports